export async function myFetch(data: any, path: string) {
  // dev
  const api = `https://asia-northeast1-confirmed-forest-dev.cloudfunctions.net/handleHttps/api${path}`;
  // default
  // const api = `https://asia-northeast1-confirmed-forest.cloudfunctions.net/handleHttps/api${path}`;

  // fetch form server
  const response = await fetch(api, {
    body: JSON.stringify(data), // must match 'Content-Type' header
    headers: { 'content-type': 'application/json' },
    method: 'POST', // options: GET, POST, PUT, DELETE, etc.
    mode: 'cors', // will be modified later, options: no-cors, cors, *same-origin
  });

  // check is ok
  if (response.status !== 200) {
    return Promise.reject(response.status + ' ' + response.statusText);
  }

  // parse response
  const result = await response.json();

  return result;
}
